import { PortalRequest as request } from "@/utils/request";


export const getDatNewProductList = (params, data) => {
    return request({
        url: "/new-product/page-list",
        method: "post",
        params: params,
        data,
    });
};

export const getProductReplaceList = (params, data) => {
    return request({
        url: "/new-product/replace-page-list",
        method: "post",
        params: params,
        data,
    });
};


export const getDatNewProductInfo = (id) => {
    return request({
        url: `/new-product/info/${id}`,
        method: "get",
    });
};


export const getNewProductByOldProductId = (oldProductId) => {
    return request({
        url: `/new-product/get-new-product-by-old-product-id`,
        method: "get",
        params:{oldProductId}
    });
};


export const getProducListByCondition = ( data) => {
    return request({
        url: "/new-product/get-product-list-by-condition",
        method: "post",
        data,
    });
}
